// extracted by mini-css-extract-plugin
export var reason = "reason-module--reason--2Cpxu";
export var reasonTitle = "reason-module--reasonTitle--1F0id";
export var reasons = "reason-module--reasons--2i7IP";
export var reasonItem = "reason-module--reasonItem--1H675";
export var reasonDescription = "reason-module--reasonDescription--35lnp";
export var reasonImage = "reason-module--reasonImage--2OB7J";
export var centerHeading = "reason-module--centerHeading--1lNgw";